import { useMemo } from 'react';

import Typography from '@/components/typography';
import { AUTH_ACTIONS } from '@/constants/constants';
import { ExportMenuButton } from '@/features/selectionsPanel/exportMenu/exportMenuLink';
import { useFooterButtonFunctions } from '@/features/selectionsPanel/hooks/useFooterButtonFunctions';
import { useSelectionsPanelContext } from '@/features/selectionsPanel/selectionsPanelProvider';
import { useAuth } from '@/providers/auth-provider';

export const SelectionReportTypeOptions = () => {
  const { userCanMakeQuickMarketAnalysisReports, userCanMakeAerialMapReports } =
    useAuth();
  const { setIsAerialReportPanelOpen, selectedComps } =
    useSelectionsPanelContext();

  const {
    compReportButtonOptions: { onClick: onMarketAnalysisClick },
    insightReportButtonOptions: {
      onClick: onPropertyAnalysisClick,
      disabled: isPropertyAnalysisDisabled,
      disabledText: propertyAnalysisDisabledText,
    },
  } = useFooterButtonFunctions();

  const aerialMapsTooltip = useMemo(() => {
    if (!userCanMakeAerialMapReports) return AUTH_ACTIONS.UPGRADE_TO_ACCESS;
    return '';
  }, [userCanMakeAerialMapReports]);

  const marketAnalysisTooltip = useMemo(() => {
    if (!userCanMakeQuickMarketAnalysisReports)
      return AUTH_ACTIONS.UPGRADE_TO_ACCESS;
    if (!selectedComps?.length) return 'Add sales using the Sold Land layer.';
    return '';
  }, [selectedComps, userCanMakeQuickMarketAnalysisReports]);

  return (
    <div className="pt-4">
      <Typography className="px-4 pb-1" variant="button2">
        Reports
      </Typography>
      <ExportMenuButton
        disabled={isPropertyAnalysisDisabled}
        label="Property Analysis"
        tooltip={propertyAnalysisDisabledText}
        onClick={onPropertyAnalysisClick}
      />
      <ExportMenuButton
        disabled={!userCanMakeAerialMapReports}
        label="Aerial Maps"
        tooltip={aerialMapsTooltip}
        onClick={() => setIsAerialReportPanelOpen(true)}
      />
      <ExportMenuButton
        disabled={
          !userCanMakeQuickMarketAnalysisReports || !selectedComps?.length
        }
        label="Market Analysis"
        tooltip={marketAnalysisTooltip}
        onClick={onMarketAnalysisClick}
      />
    </div>
  );
};
